import React from 'react';
import { renderIntoContainer, unmountContainer } from 'react/root/containerRoot';
import getCircleLoaderElement from 'functions/getCircleLoaderElement';

export class LadderPopup {
	static shownPromises = new Set();
	static hiddenPromises = new Set();
	static isShown = false;

	static create(content, title, options = {}) {
		let modal = $('#bootstrap-modal').modal(options);
		unmountContainer(modal.findCache('.modal-body')[0]);
		LadderPopup.setupLadderPopupAutoSubmit(modal);
		if(!modal.data('buttonTemplate')) {
			modal.data('buttonTemplate', modal
				.find('button.template')
				.attr('data-dismiss', null)
				.removeClass('template').remove());
		}

		let clickableButtons = {};

		let footer = modal.findCache('.modal-footer').show();
		footer.empty();
		if(options.buttons) {
			if(options.buttons === true) {
				options.buttons = [
					{
						dismiss: true,
						disableOnClick: true,
						text: 'Close',
					}
				];
			}

			for(let buttonData of options.buttons) {
				let buttonItem = modal.data('buttonTemplate').clone();
				if(buttonData.dismiss) {
					buttonItem.attr('data-dismiss', 'modal');
				}
				if(buttonData.click) {
					buttonItem.on('click', function() {
						if(buttonData.disableOnClick) {
							$(this).prop('disabled', true);
						}
						buttonData.click(modalPopupCallbackData);
					});
					if(!modal.data('submitButton') || buttonData.defaultSubmit) {
						//Default to setting a button with a click event as the auto submit button
						modal.data('submitButton', buttonItem);
					}
				}
				buttonItem.addClass('active_selectable_button');
				if(buttonData.className) {
					buttonItem.addClass(buttonData.className);
				}
				buttonItem.text(buttonData.text);
				buttonItem.appendTo(footer);
				clickableButtons[buttonData.text] = buttonItem;
			}
		}
		else {
			modal.findCache('.modal-footer').hide();
		}
		delete options.buttons;

		if(React.isValidElement(content)) {
		}
		else {
			modal.findCache('.modal-body').html(content).show();
		}

		if(title) {
			modal.findCache('.modal-header').show();
			modal.findCache('.modal-title').html(title);
		}
		else {
			modal.findCache('.modal-header').hide();
		}

		let dialog = modal.findCache('.modal-dialog');

		if(false && options.launchOffset) {
			modal.show();
			let dialogHeight = dialog.height(); //So that the height can be calculated
			modal.hide();
			let windowElement = $(window);
			let x = windowElement.width() / 2;
			let y = windowElement.height() / 2;
			x = options.launchOffset.left - x;
			y = options.launchOffset.top - y;
			let scale = 0.2;

			//need to calculate the height of the content first...
			dialog.css({
				left: options.launchOffset.left,
				top: options.launchOffset.top,
				width: options.launchOffset.width,
				height: options.launchOffset.height,
			});

			// setTimeout(function(){
			// 	dialog.css('transform','translate3d('+x+'px, '+y+'px , 0) scale('+scale+')');
			// 	dialog.css('background-color','red');
			// 	dialog.addClass('custom-start');
			// },50);


		}
		else {
			dialog.css('transform', '');
			dialog.removeClass('custom-start');
		}

		let dismissPromiseResolve = null;
		let openPromiseResolve = null;
		const modalPopupCallbackData = {
			popup: modal,
			loading: null,
			dismiss: function(exitMessage) {
				if(exitMessage) {
					modal.findCache('.modal-header').show();
					modal.findCache('.modal-title').html(exitMessage);

					modal.findCache('.modal-footer').hide();
					modal.findCache('.modal-body').hide();

					setTimeout(() => {
						LadderPopup.close();
					}, 1500);
				}
				else {
					LadderPopup.close();
				}
				return this;
			},
			getBody: function() {
				//Warning this is reused.
				return modal.findCache('.modal-body');
			},
			onDismiss: new Promise((resolve) => {
				unmountContainer(modal.findCache('.modal-body')[0]);
				dismissPromiseResolve = resolve;
			}),
			onOpen: new Promise((resolve) => {
				if(React.isValidElement(content)) {
					renderIntoContainer(
						content,
						modal.findCache('.modal-body').show()[0]
					);
				}
				openPromiseResolve = resolve;
			}),
			changeTitleText: function(newTitle) {
				modal.findCache('.modal-title').text(newTitle);
				return this;
			},
			updateContent: function(newContent) {
				if(this.loading) {
					modal.removeClass('modal-loading');
					this.loading.remove();
					this.loading = null;
				}
				if(React.isValidElement(newContent)) {
					renderIntoContainer(
						newContent,
						modal.findCache('.modal-body').show()[0]
					);
				}
				else {
					modal.findCache('.modal-body').html(newContent);
				}
				return this;
			},
			showLoader: function() {
				this.loading = getCircleLoaderElement();
				let applyLoader = () => {
					modal.addClass('modal-loading');
					modal.findCache('.modal-body').prepend(this.loading);
				};
				for(let i = 0; i < 2; i++) {
					setTimeout(() => {
						if(this.loading) {
							applyLoader();
						}
					}, (i + 1) * 500);
				}

				return this;
			},
			clickButton: function(buttonText) {
				if(clickableButtons[buttonText]) {
					clickableButtons[buttonText].trigger('click');
				}
			}
		};

		modal.on('hidden.bs.modal', function() {
			LadderPopup.isShown = false;
			dismissPromiseResolve(modal);
			modal.off('hidden.bs.modal');
		});


		//This happens if the modal was already opened and simply had content switched in
		if(LadderPopup.isShown) {
			openPromiseResolve(modal);
		}
		else {
			modal.on('shown.bs.modal', function() {
				LadderPopup.isShown = true;
				openPromiseResolve(modal);
				modal.off('shown.bs.modal');
			});
		}

		modalPopupCallbackData.onDismiss.then(() => {
			modalPopupCallbackData.getBody().off();
		});
		return modalPopupCallbackData;
	}

	static setupLadderPopupAutoSubmit(modal) {
		modal.data('submitButton', null);
		if(modal.data('autoSubmit')) {
			return;
		}
		modal.data('autoSubmit', true);
		modal.on('submit', function(e) {
			e.preventDefault();
			if(modal.data('submitButton')) {
				modal.data('submitButton').click();
			}
		});
	}

	static close() {
		$('#bootstrap-modal').modal('hide');
	}
}

LadderPopup.lastPopup = null;